/**
 * Stock adjustments list route — mounts `<StockAdjustmentsPage />`.
 *
 * @see apps/web/src/features/inventory/stock/stock-adjustments-page.tsx
 */
import { createFileRoute } from "@tanstack/react-router";
import { StockAdjustmentsPage } from "../../../../features/inventory/index.ts";
import { WorkspaceShell } from "../../../../features/workspace/index.ts";

export const Route = createFileRoute("/(workspace)/inventory/stock-adjustments/")({
  component: StockAdjustmentsRoute,
});

function StockAdjustmentsRoute() {
  return (
    <WorkspaceShell
      breadcrumbs={[{ label: "Inventory", to: "/" }, { label: "Adjustments" }]}
      viewportClassName="p-0"
      contentClassName="max-w-none"
    >
      <StockAdjustmentsPage />
    </WorkspaceShell>
  );
}
